import { jsx as _jsx } from "react/jsx-runtime";
import { toUserCardProps, UserCard } from "../../user-card/user-card";
import { createColumnHeader } from "./column-header";
/**
 * Create a column that displays user data using the UserCard component
 */ export function createUserCardColumn(accessorKey, title, options = {}) {
    const { variant = "name-only", itemVariant, size, fallback = "-", sticky, enableSorting = true, enableFiltering = false, userLookup } = options;
    return {
        accessorKey,
        maxSize: 384,
        meta: {
            label: title,
            sticky,
            ...enableFiltering && {
                filterType: "text"
            }
        },
        header: createColumnHeader(title),
        cell: ({ row })=>{
            const user = row.original[accessorKey];
            if (!user) {
                return fallback;
            }
            const props = toUserCardProps(user);
            const lookupEntry = userLookup?.get(user._id);
            return /*#__PURE__*/ _jsx("div", {
                className: "overflow-hidden max-w-96",
                children: /*#__PURE__*/ _jsx(UserCard, {
                    user: {
                        ...props,
                        deletedAt: lookupEntry?.deletedAt ?? props.deletedAt,
                        status: lookupEntry?.status ?? props.status
                    },
                    variant: variant,
                    itemVariant: itemVariant,
                    size: size
                })
            });
        },
        accessorFn: (row)=>{
            const user = row[accessorKey];
            // Return plain full name for sorting/filtering — the "(deleted)" suffix is presentation-only
            return user ? `${user.firstName} ${user.lastName}` : "";
        },
        enableSorting,
        enableColumnFilter: enableFiltering
    };
}

//# sourceMappingURL=user-card-column.js.map